import { render, staticRenderFns } from "./inner_rep.vue?vue&type=template&id=480b4f0b&scoped=true&"
import script from "./inner_rep.vue?vue&type=script&lang=js&"
export * from "./inner_rep.vue?vue&type=script&lang=js&"
import style0 from "./inner_rep.vue?vue&type=style&index=0&id=480b4f0b&scoped=true&lang=less&"
import style1 from "./inner_rep.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480b4f0b",
  null
  
)

export default component.exports